import React from 'react';
import { createRoot } from 'react-dom/client';

import './_entry.on-first-load';
import './assets/segment-script';

import App from './pages/properties/embed_property_list/EmbedPropertyEntryComponent';
import ConfigProvider from './providers/ConfigProvider';

import '../src/pages/properties/embed_property_list/embedlist.scss';

const container = document.getElementById('root');

const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(<ConfigProvider>{() => <App />}</ConfigProvider>);

if (module.hot) module.hot.accept();
